import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { walkClaimText } from '../../../../lib/walkClaimText';
import { PowerIntentIntroStrip } from './PowerIntentIntroStrip';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const RateStructuresSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.powerAnalysis?.rateStructure;
  return (
    <SectionShell label={label} hasData={!!text}>
      <PowerIntentIntroStrip report={report} focus="rates" />
      {text && (
        <EditorialSubsection theme={theme} label="Tariff assessment">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
